













import { Component, Prop, Vue } from 'vue-property-decorator'
import { Location } from 'vue-router'

@Component
export default class DrawerCell extends Vue {
  @Prop({ default: '' })
  label: string

  @Prop({ default: '' })
  icon: string

  @Prop({ default: null })
  to: string | Location | null

  @Prop({
    default: () => {
      return { name: 'Home' }
    }
  })
  bounce: string | Location

  get target (): string | Location | null {
    if (this.to) {
      const to = this.$router.resolve(this.to)
      if (this.$route.fullPath === to.href) {
        return this.bounce
      }
      return this.to
    }
    return null
  }
}
